/* Utility Function - Open and accordions */

/* Trigger Class = "accordion" */
/* Content must be next direct sibling, with the class "accordion__content" */
var accordion = document.getElementsByClassName("accordion");

for (i = 0; i < accordion.length; i++) {
  accordion[i].addEventListener("click", function() {
    var content = this.nextElementSibling;
    this.classList.toggle("open");
    content.classList.toggle("open");

    if (content.style.maxHeight){
      content.style.maxHeight = content.scrollHeight + "px";
      this.dataset.accordionicon = "+"
      setTimeout(() => {
      content.style.maxHeight = null;
      content.classList.remove('has-opened');
      }, 1);
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      this.dataset.accordionicon = "-"
      setTimeout(() => {
        content.style.maxHeight = "none";
        content.classList.add('has-opened');
      }, 200);
    } 
  });
}

/* Utility Function - Freeze Body */
freezeBodyToggle = (open) => {
  body = document.querySelector('body');

  if (open == true) {
    body.classList.remove('freezeBody');
  } else if (open == false) {
    body.classList.add('freezeBody');
  }
}

/* Handle auto-playing videos after page has loaded. */
window.addEventListener('load', function () {
  document.querySelectorAll('video').forEach((video) => {
    video.play();
  })
})

/* Stores Product Form Headers */
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/* Handle Checkout Button Alert When Users Havn't Agreed To Terms */
function termsNotification() {
  let checkoutBtnWrapper = document.querySelector('.checkout-btn-container'),
    termsboxText = document.querySelector('.cart-attribute__field label');
  
  if(checkoutBtnWrapper.querySelector('[style*="pointer-events: none"]')) {
    termsboxText.style.color = '#de6060';
    termsboxText.style.fontSize = '1rem';
    setTimeout(() => {
      termsboxText.style.color = 'var(--clr-dark)';
      termsboxText.style.fontSize = '0.9rem';
    }, 500)
  }
}